import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import MetricsAPI from "@/api/Metrics/Metrics.js";
import convertBytesToSize from "@/utils/convertBytesToSize";
import { timezone } from "@/utils/timezoneResolver";
import CoreWidget from "./CoreWidget";

const EvidenceSummaryWidget = () => {
  const metrics = [
    {
      metric: "evidenceSummary",
      args: [
        timezone,
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
    },
    {
      metric: "evidenceSummary",
      args: [
        timezone,
        moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
        moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      ],
    },
  ];

  const { data } = useQuery({
    queryKey: ["metrics", { metrics }],
    queryFn: () => MetricsAPI.getMetrics({ metrics }),
  });

  if (!data) return null;

  const evidenceSummaryThisMonth = data?.data?.[0]?.evidenceSummary || {};
  const evidenceSummaryLastMonth = data?.data?.[1]?.evidenceSummary || {};

  // calculate percentage change
  let percentageChange: number | string =
    ((evidenceSummaryThisMonth.evidence_count -
      evidenceSummaryLastMonth.evidence_count) /
      evidenceSummaryLastMonth.evidence_count) *
    100;

  percentageChange = percentageChange.toFixed(2);

  const evidenceSummaryDetails = [
    {
      label: "In Custody",
      value: evidenceSummaryThisMonth?.in_custody_count || 0,
    },
    {
      label: "Un-Tracked",
      value: evidenceSummaryThisMonth?.untracked_count || 0,
    },
    {
      label: "Total Capacity",
      value: convertBytesToSize(evidenceSummaryThisMonth.total_size_bytes),
    },
  ];

  const itemsPlural =
    evidenceSummaryThisMonth.evidence_count > 1 ? "Items" : "Item";

  return (
    <>
      <CoreWidget
        statTitle="Evidence Summary (This Month)"
        statValue={`${evidenceSummaryThisMonth.evidence_count} ${itemsPlural}`}
        percentageChange={percentageChange}
        detailItems={evidenceSummaryDetails}
      />
    </>
  );
};

export default EvidenceSummaryWidget;
